export const marketNames = {
  allMarkets: "All"
};
